import { render, staticRenderFns } from "./SalePDFpreview.vue?vue&type=template&id=1b66d42e&scoped=true&"
import script from "./SalePDFpreview.vue?vue&type=script&lang=js&"
export * from "./SalePDFpreview.vue?vue&type=script&lang=js&"
import style0 from "./SalePDFpreview.vue?vue&type=style&index=0&id=1b66d42e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b66d42e",
  null
  
)

export default component.exports